export const colFull = {
    xs: { span: 24, offset: 0 }, //<576
    sm: { span: 24, offset: 0 }, //>576
    md: { span: 24, offset: 0 }, // >768
    lg: { span: 24, offset: 0 }, // > 992
    xl: { span: 24, offset: 0 }, // > 1200
    xxl: { span: 24, offset: 0 }, // > 1600
};

export const colInputs = {
    xs: { span: 24, offset: 0 }, //<576
    sm: { span: 24, offset: 0 }, //>576
    md: { span: 12, offset: 0 }, // >768
    lg: { span: 12, offset: 0 }, // > 992
    xl: { span: 12, offset: 0 }, // > 1200
    xxl: { span: 12, offset: 0 }, // > 1600
};

export const colFoto = {
    xs: { span: 24, offset: 0 }, //<576
    sm: { span: 6, offset: 0 }, //>576
    md: { span: 6, offset: 0 }, // >768
    lg: { span: 6, offset: 0 }, // > 992
    xl: { span: 4, offset: 0 }, // > 1200
    xxl: { span: 4, offset: 0 }, // > 1600
};

export const colAllInputs = {
    xs: { span: 24, offset: 0 }, //<576
    sm: { span: 18, offset: 0 }, //>576
    md: { span: 18, offset: 0 }, // >768
    lg: { span: 18, offset: 0 }, // > 992
    xl: { span: 20, offset: 0 }, // > 1200
    xxl: { span: 20, offset: 0 }, // > 1600
};
